import http from "../http-common";

const getTenantInfo = () => {
    return http.get("/tenant-info");
};

const TenantService = {
    getTenantInfo
};

export default TenantService;